import useAuth from './useAuth'

export default function useClosedAnnouncements(): string[] {
  /**
   * The current user.
   */
  const { currentUser } = useAuth()

  /**
   * Get the closed announcements from the local storage.
   */
  const closedAnnouncements = JSON.parse(localStorage.getItem('closedAnnouncements') ?? '{}')

  // Fix legacy data structure in order to support user specific announcements.
  if ('announcements' in closedAnnouncements) {
    if (currentUser?.id) {
      closedAnnouncements[currentUser.id] = closedAnnouncements.announcements
      delete closedAnnouncements.announcements
    }
  }

  return currentUser?.id && currentUser.id in closedAnnouncements
    ? closedAnnouncements[currentUser.id]
    : []
}
